module.exports = __webpack_public_path__ + "img/base.f3e0ecb0.svg";